module.exports = __webpack_public_path__ + "static/media/country_ms.b58ae33d.webp";